import { IMakeRequest } from '../../utils/request';
import { EXPERIMENTS } from './model';

export interface IExperiment {
  abGroup: number;
  name: string;
}

interface IGetExperimentsResponse {
  data: {
    experiments: IExperiment[];
  };
}

export const isExperimentActive = (experiments: IExperiment[], experimentName: string): boolean => {
  const experiment = experiments.find(({ name }) => name === experimentName);

  return !!(experiment && experiment.abGroup);
};

export function getExperiments(makeRequest: IMakeRequest, cookies: string): Promise<IExperiment[]> {
  const experimentsQuery = EXPERIMENTS.map(name => `experiments=${encodeURIComponent(name)}`).join('&');

  return makeRequest({
    headers: [cookies && ['Cookie', cookies]].filter(h => !!h) as [string, string][],
    method: 'GET',
    uri: {
      path: '/cian-api/site/v1/get-ab-experiments/',
      query: `${experimentsQuery}`,
    },
  }).then((response: IGetExperimentsResponse) => response.data.experiments);
}
